import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { JobNotificationCardModel } from './job-notification-card.model';
import { AbstractNotificationCardComponent } from '../abstract-notification-card/abstract-notification-card.component';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-job-notification-card',
  styleUrls: ['./job-notification-card.component.scss'],
  templateUrl: './job-notification-card.component.html',
  imports: [AbstractNotificationCardComponent, MatProgressBar],
})
export class JobNotificationCardComponent {
  @Output() public closeEvent = new EventEmitter<void>();
  @Input() public jobNotification: JobNotificationCardModel;
  @Input() public notificationIcon = 'alarm';
  @Input() public pendingMessage = 'Fichiers en cours de préparation';
  @Input() public succeedMessage = 'Fichiers disponibles';

  public onCloseClickedHandler(): void {
    this.closeEvent.emit();
  }
}
